export default Object.freeze({
  ACTIONS: {
    MUTATE_DIRECT_PROPS: "AUTOSCAN_MUTATE_DIRECT_PROPS",
    RESET: "AUTOSCAN_RESET",
  },
});
